export class ApiProofUrlError extends Error {}

const usesHttpProtocol = (url: URL): boolean =>
  url.protocol === "http:" || url.protocol === "https:";

export const resolveApiProofUrl = (
  proofUrl: string,
  apiBaseUrl: string | undefined = process.env.NEXT_PUBLIC_URL_API,
): string => {
  if (proofUrl.trim() === "") {
    throw new ApiProofUrlError("Proof URL must not be empty");
  }

  if (proofUrl !== proofUrl.trim()) {
    throw new ApiProofUrlError(
      "Proof URL must not contain surrounding whitespace",
    );
  }

  try {
    const absoluteProofUrl = new URL(proofUrl);

    if (!usesHttpProtocol(absoluteProofUrl)) {
      throw new ApiProofUrlError("Proof URL must use HTTP or HTTPS");
    }

    return proofUrl;
  } catch (error) {
    if (!(error instanceof TypeError)) {
      throw error;
    }

    if (!apiBaseUrl) {
      throw new ApiProofUrlError(
        "NEXT_PUBLIC_URL_API is required for relative proof URLs",
      );
    }

    let normalizedApiBase: URL;

    try {
      normalizedApiBase = new URL(
        apiBaseUrl.endsWith("/") ? apiBaseUrl : `${apiBaseUrl}/`,
      );

      if (!usesHttpProtocol(normalizedApiBase)) {
        throw new ApiProofUrlError(
          "NEXT_PUBLIC_URL_API must use HTTP or HTTPS",
        );
      }
    } catch (apiBaseError) {
      if (!(apiBaseError instanceof TypeError)) {
        throw apiBaseError;
      }

      throw new ApiProofUrlError("NEXT_PUBLIC_URL_API must be an absolute URL");
    }

    if (proofUrl.startsWith("/")) {
      // Root-relative proofs already contain /api, so using the origin avoids
      // duplicating the configured API base path.
      return `${normalizedApiBase.origin}${proofUrl}`;
    }

    return new URL(proofUrl, normalizedApiBase).toString();
  }
};
